import React from "react";
import Products from "./Products";
import Intro from "./Intro";
import "./Home.css";
import Shipping from "./Shipping";
import ProductsList from "./ProductsList";
import AffiliateBanners from "./AffiliateBanners";

const Homepage = () => {
  return (
    <div className="home">
      <Intro />
      <Shipping />
      <div className="home__container">
        <div className="home__title">
          <h1 className="category-name">
            Hot Wheels <span className="category-name__underline"></span>
          </h1>
          <ProductsList catId={1} catName="Hot Wheels" />
        </div>
        <div className="home__title">
          <h1 className="category-name">LEGO Bilar</h1>
          <ProductsList catId={2} catName="LEGO Bilar" />
        </div>
        <AffiliateBanners type="hero" />
        <div className="home__title">
          <h1 className="category-name">Siku Bilar</h1>
          <ProductsList catId={3} catName="Siku Bilar" />
        </div>
        <div className="home__title">
          <h1 className="category-name">RC Bilar</h1>
          <ProductsList catId={4} catName="RC Bilar" />
        </div>
      </div>
    </div>
  )
}

export default Homepage;